import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

type SuccessMessageProps = {
  headingText: string;
  subheadingText: string;
  buttonText: string;
  to?: string;
  onClick?: () => void;
};

export const OrganizationSuccessMessage = (
  props: SuccessMessageProps,
): JSX.Element => {
  const { headingText, subheadingText, buttonText, to, onClick } = props;

  return (
    <Stack
      spacing={2}
      sx={{
        height: '100%',
        minHeight: '100%',
        flex: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack
        spacing={2}
        sx={{
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <Typography variant="h2" align="center">
          <b>{headingText}</b>
        </Typography>

        <Typography align="center">{subheadingText}</Typography>
      </Stack>

      <Button fullWidth size="large" component={Link} to={to} onClick={onClick}>
        {buttonText}
      </Button>
    </Stack>
  );
};
